import { render, staticRenderFns } from "./AssessmentGlobalMeasureSingleTaskModal.vue?vue&type=template&id=37d3dbec&"
import script from "./AssessmentGlobalMeasureSingleTaskModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalMeasureSingleTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports